import React from 'react';

function SearchBar({ searchQuery, onSearchChange, loading }) {
  return (
    <div className="dashboard__search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8"/>
        <path d="m21 21-4.35-4.35"/>
      </svg>
      <input 
        type="text"
        placeholder="Search entries..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="dashboard__search-input"
      />
      {loading && (
        <div className="dashboard__search-loading">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
          </svg>
        </div>
      )}
      {searchQuery && !loading && (
        <button 
          className="dashboard__search-clear"
          onClick={() => onSearchChange('')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      )}
    </div>
  );
}

export default SearchBar;
